import React, { useContext, useState } from 'react';
import './BookingCard.css';
import HeroSearch from './HeroSearch';
import { LanguageContext } from '../context/LanguageContext';


const BookingCard = ({ price }) => {
  const {t} = useContext(LanguageContext); 
  

  return (
    <div className="booking-card">
      <div className="booking-card-price">
        <p className="price-label">{t("roomTypes", "from")} </p>
        <p className="price-large">{price} €</p>
        <p className="price-label">{t("roomTypes", "night")}</p>
      </div>
      
      <div className="booking-card-form">
        <HeroSearch />
      </div>
    </div>
  );
};

export default BookingCard;